var _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu17466330(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c5996f",
    d: "m27.668 3.333c.884 0 1.731.351 2.356.976s.976 1.473.976 2.356v.003c0 .884-.351 1.731-.976 2.356s-1.472.976-2.356.976h-23.336c-.884 0-1.731-.351-2.356-.976s-.976-1.472-.976-2.356v-.003c0-.883.351-1.731.976-2.356s1.472-.976 2.356-.976zm0 2h-23.336c-.353 0-.692.141-.942.39-.25.25-.39.589-.39.942v.003c0 .353.14.692.39.942s.589.39.942.39h23.336c.353 0 .692-.14.942-.39s.39-.589.39-.942v-.003c0-.353-.14-.692-.39-.942-.25-.249-.589-.39-.942-.39z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5996f",
    d: "m27.668 12.667c.884 0 1.731.351 2.356.976.625.624.976 1.472.976 2.356v.002c0 .884-.351 1.732-.976 2.356-.625.625-1.472.976-2.356.976h-23.336c-.884 0-1.731-.351-2.356-.976-.625-.624-.976-1.472-.976-2.356v-.002c0-.884.351-1.732.976-2.356.625-.625 1.472-.976 2.356-.976zm0 2h-23.336c-.353 0-.692.14-.942.39s-.39.588-.39.942v.002c0 .354.14.692.39.942s.589.39.942.39h23.336c.353 0 .692-.14.942-.39s.39-.588.39-.942v-.002c0-.354-.14-.692-.39-.942s-.589-.39-.942-.39z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5996f",
    d: "m27.668 22c.884 0 1.731.351 2.356.976s.976 1.472.976 2.356v.003c0 .883-.351 1.731-.976 2.356s-1.472.976-2.356.976h-23.336c-.884 0-1.731-.351-2.356-.976s-.976-1.473-.976-2.356v-.003c0-.884.351-1.731.976-2.356s1.472-.976 2.356-.976zm0 2h-23.336c-.353 0-.692.14-.942.39s-.39.589-.39.942v.003c0 .353.14.692.39.942.25.249.589.39.942.39h23.336c.353 0 .692-.141.942-.39.25-.25.39-.589.39-.942v-.003c0-.353-.14-.692-.39-.942s-.589-.39-.942-.39z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu17466330);
export default __webpack_public_path__ + "static/media/menu_17466330.1189132fc6c32624fed626ab508c670a.svg";
export { ForwardRef as ReactComponent };